/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.30/esri/copyright.txt for details.
*/
import{generateUID as o}from"../../../../core/uid.js";class r{constructor(){this.id=o()}}export{r as ContentObject};
